import { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import EmbedYoutube from '../utils/EmbedYoutube/EmbedYoutube';
import { WhyLearnJavaWrapper } from './WhyLearnJava.styled';
import img1 from './../../resources/whyLearnJava/accordion1-1.png';
import img2 from './../../resources/whyLearnJava/accordion1-2.png';
import img3 from './../../resources/whyLearnJava/accordion1-3.png';
import img4 from './../../resources/whyLearnJava/accordion1-4.jpg';
import img5 from './../../resources/whyLearnJava/accordion1-5.png';

function WhyLearnJava() {
  const [open, setOpen] = useState('');
  const toggle = (id: any) => {
    if (open === id) {
      setOpen('');
    } else {
      setOpen(id);
    }
  };

  return (
    <WhyLearnJavaWrapper>

      <header className="entry-header">
        <h1 className="entry-title" itemProp="headline">Why learn Java?</h1>
      </header>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
        <p className="text-align-justify">
          Java is a compelling programming language. Comparatively, the demand for developers with knowledge of java is very high, than Python or any other programming language.
        </p>
      </div>
      <EmbedYoutube videoType="video" videoList={["rcHjnnUKdXQ"]} />

      <div>
        <Accordion open={open} toggle={toggle}>
          <AccordionItem>
            <AccordionHeader targetId="1">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>How and why is java better than other programming languages?</span>
            </AccordionHeader>
            <AccordionBody accordionId="1">
              <div>
                <h6><strong>OPEN SOURCE</strong></h6>
                <p className="text-align-justify">
                  The source code of Java is released under GPL i.e. General Public License, which allows users to study, use, change, and distribute it to anyone. Indeed, Java is a freely available programming language.
                </p>
              </div>
              <figure className="aligncenter size-large is-resized">
                <img decoding="async" width="1024" height="576" src={img1} alt="" className="lazy-loaded" style={{width:'600px'}} sizes="auto, (max-width: 1024px) 100vw, 1024px" />
              </figure>
              <h6><strong>PLATFORM INDEPENDENT</strong></h6>
              <p className="text-align-justify">So, it means that the byte code of java is platform-independent, can be distributed and run on all operating systems. Hence, the class file is platform-independent.</p>
              <figure className="aligncenter is-resized">
                <img decoding="async" width="1024" height="576" src={img2} alt="" className="lazy-loaded" style={{width:'600px'}} sizes="auto, (max-width: 1024px) 100vw, 1024px" />
              </figure>
              <h6><strong>OBJECT ORIENTED</strong></h6>
              <p className="text-align-justify">
                It follows a programming model that is based on the concept of Objects, where each object has a unique attribute and behavior. Basically, it helps us build reusable blocks of code.
              </p>
              <figure className="aligncenter size-large is-resized has-custom-border is-style-default">
                <img decoding="async" width="1024" height="576" src={img3} alt="" className="lazy-hidden" style={{borderRadius:'2px',width:'600px'}} sizes="auto, (max-width: 1024px) 100vw, 1024px" />
              </figure>
              <h6><strong>MULTI THREADED</strong></h6>
              <p className="text-align-justify">
                It means that the execution of multiple threads can be done concurrently at a time so that CPU can be utilized to its maximum. So, in simple words, it is a kind of multi-tasking.
              </p>
              <figure className="aligncenter size-large is-resized">
                <img decoding="async" src={img4} alt="" className="reduced-img"  />
              </figure>
              <h6><strong>SECURE AND ROBUST</strong></h6>
              <p className="text-align-justify">
                It is secure as while execution the JVM scans for viruses and malicious files in the class file, .i.e, the byte code before converting it to machine language. It is robust or let’s just say strong because it provides features like automatic garbage collection, exception handling, etc
              </p>
              <figure className="aligncenter size-large is-resized">
                <img decoding="async" width="1024" height="576" src={img5} alt="" className="lazy-hidden" style={{width:'600px'}} sizes="auto, (max-width: 1024px) 100vw, 1024px" />
              </figure>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="2">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>Where is Java used in real-time?</span>
            </AccordionHeader>
            <AccordionBody accordionId="2">
              <ul className="text-align-left">
                <li>Big Data Frameworks</li>
                <li>Android OS</li>
                <li>Big Data Analysis</li>
                <li>Artificial Intelligence</li>
                <li>Data Science Projects</li>
                <li>Web Pages</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="3">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>Which apps are developed using Java?</span>
            </AccordionHeader>
            <AccordionBody accordionId="3">
              <ul className="text-align-left is-style-default has-times-new-roman-font-family has-custom-font has-custom-letterspacing">
                <li>Uber</li>
                <li>Netflix</li>
                <li>Spotify</li>
                <li>Instagram</li>
                <li>Facebook</li>
                <li>Google</li>
                <li>Twitter</li>
                <li>Slack</li>
                <li>Amazon</li>
                <li>Pinterest</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="4">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>How Java makes Programming easy with its features?</span>
            </AccordionHeader>
            <AccordionBody accordionId="4">
              <ul className="text-align-left has-times-new-roman-font-family has-custom-font has-custom-letterspacing">
                <li>Design Patterns</li>
                <li>JDBC Connections</li>
                <li>Spring Framework</li>
                <li>Cross-Platform Development </li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="5">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>What are the skills people look for in Java developers?</span>
            </AccordionHeader>
            <AccordionBody accordionId="5">
              <ul className="text-align-left has-times-new-roman-font-family has-custom-font has-custom-letterspacing">
                <li>OOPS</li>
                <li>Collections</li>
                <li>Exception Handling</li>
                <li>Micro Services</li>
                <li>Spring Boot </li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="6">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>How much does a Java developer get paid?</span>
            </AccordionHeader>
            <AccordionBody accordionId="6">
              <ul className="text-align-left has-times-new-roman-font-family has-custom-font has-custom-letterspacing">
                <li>Fresher: 4-5 LPA</li>
                <li>Experienced: 10-25 LPA</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="7">
              <span className="fa fa-book"></span>
              <span style={{marginLeft: '3vw'}}>How to learn Java?</span>
            </AccordionHeader>
            <AccordionBody accordionId="7">
              <ul className="text-align-left has-times-new-roman-font-family has-custom-font has-custom-letterspacing">
                <li>Learn the fundamentals of Programming </li>
                <li>Practice writing code </li>
                <li>Learn the shortcuts of IDE </li>
                <li>Follow this tutorial series</li>
                <li>Create a project on your own</li>
              </ul>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </WhyLearnJavaWrapper>
  )
};

export default WhyLearnJava;
